import React, { useState } from "react";

const Value = () => {

  const data = [
    { label: 'Total Assessable Value', value: '0.00' },
    { label: 'Total Basic Duty', value: '0.00' },
    { label: 'Total CVD', value: '0.00' },
    { label: 'Total Excise Education Cess', value: '0.00' },
    { label: 'Total Excise Secondary and Higher Education Cess', value: '0.00' },
    { label: 'Total Custom Education Cess', value: '0.00' },
    { label: 'Total Custom Secondary and Higher Education Cess', value: '0.00' },
    { label: 'Total Additional Duty', value: '0.00' },
    { label: 'Total SWS Duty', value: '0.00' },
    { label: 'Total IGST', value: '0.00' },
    { label: 'Total Duty', value: '0.00' },
  ];

  return (
    <>
      <div className="row pb-3">
        <div className="col-md-12">
          <div className="card px-3 py-2">
          <div style={{ padding: '20px', }}>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <tbody>
          {data.map((item, index) => (
            <tr key={index} style={{ borderBottom: '1px solid #ccc' }}>
              <td style={{ padding: '8px', textAlign: 'left', fontSize: '12px' }}>{item.label}</td>
              <td style={{ padding: '8px', textAlign: 'right', fontSize: '12px' }}>{item.value} INR</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ fontSize: '12px', color: '#666', marginTop: '10px' }}>
        Note: If you have made any changes, please save the job to get updated values.
      </p>
    </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Value
